// extracted by mini-css-extract-plugin
module.exports = {"mediaPlayer":"media-player_mediaPlayer__BoXKJ","mediaPlayerController":"media-player_mediaPlayerController__2EZeq"};